module.exports = __webpack_public_path__ + "img/license.14238c29.jpg";